import { useId } from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

type Props = {
  isYearly: boolean;
  onChange: () => void;
};

export const PricingSwitch = ({ isYearly, onChange }: Props) => {
  const id = useId();

  return (
    <div className="flex flex-col items-center">
      <span className="font-normal text-orange-600 dark:text-orange-300">
        Get ~2 months for free with <span className="font-bold">Annual</span> plan
      </span>
      <div className="flex items-center gap-2.5">
        <Label
          className={`cursor-pointer py-2.5 px-2 text-md transition-transform ${isYearly ? 'text-muted-foreground/75' : 'scale-105'}`}
          htmlFor={id}
        >
          Monthly
        </Label>
        <Switch id={id} className="scale-130" onCheckedChange={onChange} />
        <Label
          className={`cursor-pointer py-2.5 px-2 text-md transition-transform ${isYearly ? 'scale-105' : 'text-muted-foreground/75'}`}
          htmlFor={id}
        >
          Annual
        </Label>
      </div>
    </div>
  );
};
